const DEFAULT_CAP = 50;

// ORDER_CLOSE wipes the order, so the result screen reads the paid amount from here instead.
class PaidAmountByRequest {
  private readonly amounts = new Map<string, number>();

  constructor(private readonly cap: number = DEFAULT_CAP) {}

  get(paymentRequestId?: string): number | undefined {
    return paymentRequestId ? this.amounts.get(paymentRequestId) : undefined;
  }

  set(paymentRequestId: string, amount: number): void {
    this.amounts.delete(paymentRequestId);
    this.amounts.set(paymentRequestId, amount);
    if (this.amounts.size > this.cap) {
      this.amounts.delete(this.amounts.keys().next().value as string);
    }
  }

  clear(): void {
    this.amounts.clear();
  }
}

export const paidAmountByRequest = new PaidAmountByRequest();
